import React from "react";

export const aboutPage1 = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		version="1.1"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		preserveAspectRatio="none"
		x="0px"
		y="0px"
		width="329px"
		height="191px"
		viewBox="0 0 329 191"
		id="frame-1"
	>
		<defs>
			<linearGradient
				id="Gradient_2"
				gradientUnits="userSpaceOnUse"
				x1="172.44999999999993"
				y1="785.2"
				x2="1465.65"
				y2="231.59999999999997"
				spreadMethod="pad"
			>
				<stop offset="4.705882352941177%" stopColor="#2DFCD8" />

				<stop offset="5.882352941176471%" stopColor="#2BF0CE" />

				<stop offset="11.764705882352942%" stopColor="#21BBA1" />

				<stop offset="18.03921568627451%" stopColor="#198C79" />

				<stop offset="24.313725490196077%" stopColor="#136558" />

				<stop offset="30.58823529411765%" stopColor="#0F453C" />

				<stop offset="37.254901960784316%" stopColor="#0D2C27" />

				<stop offset="43.92156862745098%" stopColor="#0C1A18" />

				<stop offset="51.372549019607845%" stopColor="#0C0F0F" />

				<stop offset="59.6078431372549%" stopColor="#0C0C0C" />
			</linearGradient>

			<g id="Layer3_0_FILL">
				<path
					fill="url(#Gradient_2)"
					stroke="none"
					d="
M 1147.65 788.45
L 894.9 73.05 184.75 682.3 285.45 997.85 1147.65 788.45 Z"
				/>
			</g>

			<g id="Layer2_0_FILL">
				<path
					fill="#0C0C0C"
					stroke="none"
					d="
M 426.2 703.75
L 207.6 651.85 -17.35 777.05 -130.75 1054.65 118.55 1261.6 474.7 988.6 426.2 703.75 Z"
				/>
			</g>

			<g id="Layer1_0_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 1029.4 761.55
Q 1023.15 769.6 1022.2 777.15 1021.1 785.85 1027.25 792.75 1033.2 799.45 1042.05 800.15 1050.3779296875 800.8201171875 1057.35 795.4 1057.60234375 796.7892578125 1057.95 798.15 1060.8 809.35 1071.35 810.8 1076.45 811.5 1081.45 808.85 1086.1 806.45 1089.25 801.95 1089.32734375 801.8396484375 1089.4 801.7 1095.852734375 815.20234375 1105.65 811.35 1116.25 807.2 1120.1 794.25 1123.7 782.1 1119.1 771.6 1118.15 769.45 1115.7 770.45 1113.25 771.5 1113.95 773.75 1116.45 781.65 1114.75 789.3 1112.95 797.4 1107 802.75 1104.45 805.05 1102.4 805.3 1099.95 805.6 1097.75 803.15 1095.75 800.85 1093.85 795.1 1093.4115234375 793.7845703125 1093.05 792.45 1093.3982421875 790.7716796875 1093.55 788.95 1094 784 1093.2 775 1092.95 772.15 1090 771.65 1087 771.1 1086.35 774.1 1084.45546875 782.9626953125 1085.95 791.25 1085.698828125 792.5328125 1085.3 793.7 1083.75 798.05 1080.25 800.9 1076.25 804.2 1072 803.3 1065.8 802 1065.2 793.6 1064.83515625 788.6939453125 1066.25 783.15 1066.574609375 781.8734375 1067 780.55 1067.9 776.6 1064 775.5 1060.05 774.4 1058.85 778.3 1058.633984375 779.20078125 1058.35 780.05 1055.9625 787.21875 1048.85 790.35 1040.55 794 1034.15 787.4 1028.15 781.15 1033.3 771.95 1036.1 767 1044.45 758.6 1056.75 746.35 1072.05 737.85 1087.4 729.35 1104.3 725.4 1120.9 721.55 1145.3 722.45 1159.1 722.95 1186.55 724.75 1206.05 725.3 1227.8 725 1238.2 724.75 1248.4 724.4 1251.4 724.3 1257.55 724.15 1262.9 723.9 1266.6 723.1 1274.35 721.45 1278.15 716.05 1282.45 709.95 1277.25 703.5 1274.85 700.5 1270.25 697.2 1270.2 697.2 1262.35 691.95 1253.2 685.9 1243.15 681.3 1239.9 679.85 1238.05 683.05 1236.15 686.2 1239.4 687.75 1248.7 692.25 1256.25 697.2 1261.3 700.55 1265.3 703.95 1266.05 704.55 1268.95 706.95 1271.5 709.35 1271.2 710.8 1270.7 713.2 1265.95 714.2 1263.8 714.65 1259.2 714.9 1251.35 715.3 1235.65 715.6 1212.55 716 1190.5 715.25 1184.6 715.05 1168.35 714.1 1154.4 713.25 1146.2 713.15 1125 712.9 1107.6 716.15 1087.7 719.8 1071 728.3 1054.6 736.65 1041.45 748.9 1033.25 756.55 1029.4 761.55 Z"
				/>
			</g>

			<g id="Layer1_1_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 1313.8 603.1
Q 1344.75 640.7 1367.3 672.3 1382.35 693.4 1394.25 712.45 1401.25 723.55 1403.3 730.55 1406.75 742.25 1400.05 749.05 1398.25 750.95 1400.1 752.8 1402 754.65 1403.85 752.85 1409.5 747.45 1409.75 739 1409.95 732.15 1406.6 723.8 1403.15 715.4 1396.4 704.9 1388.2 692.95 1384.2 687.1 1360.6 652.2 1328.5 612.8 1315.35 596.65 1298.3 576.6 1289.05 565.65 1267.65 540.8 1242.5 511.5 1236.25 504 1227 492.95 1222.15 488.3 1213.6 480.15 1204.85 476.4 1184.45 467.7 1158.55 474.8 1137.35 480.6 1116.1 495.6 1115.25 496.2 1115.65 497.25 1116.05 498.35 1117.05 497.95 1120.2 496.7 1136.2 489.85 1147.9 484.8 1155.55 482.35 1178.15 475.15 1196.3 480.15 1205.45 482.7 1213.95 489.25 1220.3 494.15 1228.25 503.1 1234.85 510.5 1257.2 536.35 1295.6 580.95 1313.8 603.1 Z"
				/>
			</g>

			<g id="Layer1_2_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 949.35 528.3
Q 950.3341796875 530.3060546875 951.95 529.65 971.3859375 528.802734375 989.95 516 1005.35 505.45 1019.65 487.15 1030.8 472.75 1033.15 470 1041.15 460.55 1048.7 454.8 1057.95 447.8 1068.55 444 1079.85 439.9 1090.8 440.1 1097.7 440.25 1103.8 442.25 1110.4 444.35 1115.35 448.45 1119.4 451.75 1122.3 456.8 1123.75 459.2 1127 466.6 1127.55 467.85 1128.9 467.4 1130.2 466.95 1130.25 465.75 1130.45 457.35 1123.2 449.25 1116.9 442.25 1108.3 438.55 1098.2 434.25 1085.95 434.85 1074.9 435.45 1063.7 439.9 1044.75 447.45 1029.05 465.95 1026.8 468.6 1014.8 484 1006.2 495.05 999.7 501.3 990.05 510.6 977.45 516.7 971.8 519.45 964.3 521.6 961 522.55 950.7 525 948 525.6 949.35 528.3 Z"
				/>
			</g>

			<g id="Layer1_3_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 723.3 780.35
Q 703.35 780.65 693.45 780.65
L 480.6 780.65
Q 469.9 780.3 464.4 780.3 454.7 780.25 448.35 781.85 447.1 782.15 447.1 783.5 447.1 784.85 448.35 785.15 454 786.55 462.45 786.6 467.25 786.6 476.65 786.3
L 566.15 786.15
Q 566.2 786.15 685.5 786 696.75 786 719.35 786.35 739.35 786.45 753.1 785.5 755.25 785.35 755.25 783.3 755.25 781.2 753.1 781.05 741 780.2 723.3 780.35 Z"
				/>
			</g>

			<g id="Layer1_4_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 1368.05 770.2
Q 1368 770.95 1368.7 771.05 1374.8 772.05 1383.6 771.9 1388.6 771.8 1398.55 771.35
L 1428.15 770.65
Q 1457.45 770 1488.35 770.3 1510.3 770.5 1549 772.3 1591.95 774.3 1609.6 774.7 1611.7 774.75 1612.05 772.4 1612.45 770.05 1610.3 769.75 1583.35 765.95 1549.95 764.5 1527.1 763.5 1489.35 763.25 1458.15 763.1 1428.15 764.2 1411.7 764.8 1398.55 765.65 1388.55 766.2 1383.5 766.65 1374.75 767.45 1368.7 769.25 1368.1 769.45 1368.05 770.2 Z"
				/>
			</g>

			<g id="Layer1_5_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 672.15 386.6
Q 664.65 377 663.75 366.75 662.8 356 669.2 345.95 687.9 316.45 739.25 307.6 755.45 304.8 765.35 303.65 780 301.9 791.6 302.25 803.75 302.6 814.6 307.55 825.15 312.35 833.8 321.25 834.75 322.2 835.7 321.25 836.65 320.25 835.8 319.2 829.45 311.45 820.5 306.25 811.65 301.1 801.7 299.25 791.3 297.3 777.15 298.35 773.5 298.6 752.6 301.15 727.05 304.25 709.85 310.3 687.15 318.3 673.05 333.05 665.25 341.15 661.45 349.6 656.9 359.65 658.4 369.3 659.9 378.85 666.35 387.9 671.9 395.7 680.65 402.45 696.05 414.4 716.6 419.1 735.95 423.55 756.35 420.9 779.65 417.9 803.95 405.9 814.8 400.6 826.5 392.95 832.05 389.3 837.2 385.55 842.3 381.85 843.9 381 848.05 378.85 851.65 379.55 854.4 380.1 855.15 377.45 855.9 374.8 853.2 373.95 849 372.6 844.6 374 841.25 375.05 836.85 378.1 830.95 382.3 828 384.35 822.8 387.95 818.95 390.35 799.6 402.6 780.9 409 761.3 415.7 742.05 415.95 721.35 416.25 703.3 409 694.05 405.3 686.25 399.8 677.9 393.9 672.15 386.6 Z"
				/>
			</g>

			<g id="Layer1_6_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 911.8 317.55
Q 913.45 316.2 913 313.95 912.6 311.85 910.9 310.7 907.75 308.55 905.3 307.65 902.1 306.55 899.1 307.15 897.8228515625 307.416796875 896.75 307.95 895.5060546875 307.79375 894.2 308.2 892.5 308.7 891.9 310.3 891.35 311.75 892.1 313.4 892.4205078125 314.114453125 892.8 314.75 892.8634765625 315.5826171875 893.1 316.45 893.4 317.6 894.35 318.6 895.35 319.65 896.5 319.85 897.666015625 320.00546875 898.7 319.95 899.0001953125 320.3216796875 899.3 320.65 901.45 322.95 904.5 321.2 905.263671875 320.7619140625 905.75 320.25 909.11328125 319.7888671875 911.8 317.55 Z"
				/>
			</g>

			<g id="Layer1_7_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 864.65 324.6
Q 863.95 325.6 864.75 326.5 873.35 336.55 892.3 342.8 899.95 345.3 907.85 346.2 913.75 346.9 915.65 346.95 920.15 347 923.2 345.55 924.8 344.75 924.45 342.9 924.15 341.05 922.55 340.55 920.1 339.85 916.05 340 910.35 340.2 909.45 340.15 902 339.75 893.8 337.4 887.3 335.55 879.75 331.65 871.05 326.8 866.5 324.25 865.4 323.6 864.65 324.6 Z"
				/>
			</g>

			<g id="Layer1_8_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 812.95 411.95
Q 811.5 411.35 810.85 412.65 807 420.3 803.45 432 802.6 434.85 800.5 441.55 798.95 447.55 799.9 451.3 800.25 452.7 801.7 452.85 803.2 453 803.95 451.8 805 450.2 805.45 447.95 805.9 445.25 806.1 443.8 806.85 439.05 808.25 433.35 809.25 429.2 811 423.6 813 417.2 814 413.95 814.4 412.6 812.95 411.95 Z"
				/>
			</g>

			<g id="Layer1_9_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 842.6 408.45
Q 840.8 407.75 839.7 409.3 837.35 412.65 832.45 422.05 831.55 423.85 829.45 427.35 828 430.5 828.75 433.1 829.1 434.4 830.3 434.85 831.45 435.25 832.7 434.7 835.05 433.65 836.55 430.35 837.95 426.45 838.65 424.65 841.35 418.2 841.45 417.9 843 414 843.8 411 844.35 409.1 842.6 408.45 Z"
				/>
			</g>

			<g id="Layer1_10_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 871.3 419.3
Q 872.4 418.2 871.4 416.95 870.45 415.7 869.1 416.45 865.8 418.35 863.05 421.45 860.1 424.8 859.05 428.25 858.15 431.1 861 431.85 863.8 432.55 864.9 429.9 865.6 427.95 865.95 427 866.6 425.3 867.3 424.2 868.7 421.9 871.3 419.3 Z"
				/>
			</g>

			<g id="Layer1_11_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 896.95 421.65
Q 895.8 420.8 894.75 421.7 891.6 424.25 890.95 424.9 888.85 426.9 888 428.85 887.4 430.2 888.4 431.3 889.4 432.45 890.75 431.6 892.7 430.45 894.5 428.05 895.25 427.05 897.3 423.65 898.05 422.45 896.95 421.65 Z"
				/>
			</g>

			<g id="Layer1_12_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 936.4 429.5
Q 933.5 434.3 931.75 436.2 926 442.4 918.45 446.6 910.05 451.15 900.3 451.95 891.75 452.65 881.3 450.5 867.35 447.6 862.4 446.9 851.8 445.4 843.15 446.25 833.8 447.25 825.3 450.25 819.45 452.3 817.65 453.15 813.2 455.3 811.55 458.15 811.35 458.5 811.55 458.85 811.75 459.15 812.15 459.2 814.05 459.35 816.55 458.5 817.95 458 820.75 456.85 827 454.7 830.85 453.8 841.1 451.35 851.9 451.65 859.2 451.9 873 455 887.05 458.15 894.1 458.45 902.3 458.8 910.4 456.5 918.4 454.25 925.35 449.65 932.75 444.8 938.05 438.35 941.35 434.35 942.8 432.05 945.2 428.2 945.55 424.85 945.75 423.15 944 422.5 942.25 421.85 941.1 423 939.15 424.95 936.4 429.5 Z"
				/>
			</g>

			<g id="Layer1_13_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 816.65 471.75
Q 815.55 470.95 814.6 471.6 813.75 472.2 813.35 472.45 812.65 472.95 812.2 473.5 811.15 474.7 810.15 476.5 809.05 478.6 808.7 479.7 808.05 481.55 808.3 483.2 808.55 484.6 810.15 484.95 811.75 485.35 812.65 484.3 813.45 483.45 814.1 481.8 815.15 479.05 815.15 479
L 816.3 476.65
Q 816.9 474.7 817.3 473.7 817.7 472.6 816.65 471.75 Z"
				/>
			</g>

			<g id="Layer1_14_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 840.05 468.35
Q 839.45 468.1 839.05 468.65 838.9 468.8 838.55 469 838.15 469.2 838 469.3 837.5 469.9 837.15 470.65 836.35 472.2 836.1 474.55 835.75 476.95 836 478.6 836.15 479.65 836.75 480.45 837.2 481.05 838.25 481.85 839.05 482.45 840.1 482 841.1 481.55 841.35 480.6 841.7 479.25 841.35 477.55 840.7 474.65 840.7 474.55 840.65 473.9 840.75 471.55 840.8 471.2 840.6 470.4 840.45 469.6 840.5 469.3 840.65 468.6 840.05 468.35 Z"
				/>
			</g>

			<g id="Layer1_15_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 881.15 465.9
Q 881.3 464.75 880.15 464.65 879 464.55 878.6 465.55 876.2 471.55 874.05 475.25 873.85 475.55 871.5 479.15 869.95 481.5 869.4 483.25 869.05 484.4 870.1 485.25 871.15 486.05 872.15 485.4 876.05 482.8 878.55 476.65 880.5 471.7 881.15 465.9 Z"
				/>
			</g>

			<g id="Layer1_16_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 844.25 165.35
Q 844.9 160.85 850.1 162.6 850.8 162.85 857.7 166.5 862.85 169.2 868.6 172.65 909.05 196.75 944.65 239.65 945.6 240.75 946.9 239.8 948.15 238.8 947.3 237.65 921.75 201.65 880.1 174.4 869.75 167.65 859.3 162.1 852.65 158.6 851.25 158.1 846.1 156.3 842.8 158.7 839.9 160.85 839.6 165.1 839.4 168.05 840.55 172.5 843.1 182.5 848.3 192.45 852.6732421875 200.7728515625 858.45 207.9 832.4408203125 193.4900390625 809.5 185.65 766.35 170.9 728.1 176.75 726.6 176.95 726.25 178.65 725.95 180.25 726.95 181.25 748.5 203.8 775.35 218.6 783.2763671875 222.9486328125 791.45 226.5 783.381640625 224.580859375 768.9 221.05 749.45 216.3 736.65 214.9 718.9 212.9 703.6 215.6 701.6 215.9 701.55 217.95 701.45 219.85 702.9 220.95 736.5 246.45 776.05 259.75 779.15 260.8 780.05 257.55 780.9 254.35 777.85 253.25 742.798046875 240.5822265625 712 220.1 723.914453125 218.72421875 738.05 220.65 749.6 222.25 770.4 227.7 794.1 233.95 801.8 235.6 819.6 239.35 833.8 239.35 836.6 239.4 837.1 236.35 837.55 233.25 834.7 232.75 805.05 227.45 778.35 213.35 753.7080078125 200.3015625 734.5 181.3 769.3662109375 177.4 808.65 191.35 839.35 202.3 880.6 227.8 882.95 229.25 884.35 226.8 885.8 224.3 883.45 222.85
L 882.15 222
Q 872.79375 215.79375 865.2 207.45 857.1 198.6 851.6 187.85 848.35 181.5 846.5 175.65 845.3 172.4 844.8 170.6 843.95 167.45 844.25 165.35 Z"
				/>
			</g>

			<g id="Layer1_17_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 1067.25 241.3
Q 1067 239.35 1065.4 238.6 1053.45 232.85 1040.75 230.7 1027.8 228.5 1014.9 230.2 1008.3 231.1 1004 232.35 998.1 234.1 993.95 237.05 990.55 239.5 988.8 242.85 986.65 246.85 988.2 250.2 988.45 250.8 989.15 250.75 989.8 250.7 990.1 250.2 990.8 249.1 991.95 246.85 993.05 244.95 994.3 243.85 997.3 241.25 1002.25 239.55 1010.2 236.9 1021.3 236.45 1039.9181640625 235.7974609375 1056.65 242.75 1048.839453125 249.00625 1039.1 253.7 1028.7 258.7 1014.4 262.7 1012.2 263.35 1012.5 265.8 1012.8 268.25 1015.15 268.1 1028.9 267.3 1042.6 260.7 1055.1 254.65 1066.2 244.45 1067.45 243.25 1067.25 241.3 Z"
				/>
			</g>

			<g id="Layer1_18_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 1013.8 342.35
Q 1015.35 341.65 1018.5 339.45 1021.45 337.45 1023.3 336.7 1028.65 334.5 1035.35 335 1042.05 335.5 1047.65 339 1053.45 342.6 1056.45 348.45 1059.8 355.1 1056.5 360.4 1053.5 365.15 1046.3 367.35 1039.6 369.05 1036.3 370.25 1030.5 372.3 1027.75 375.8 1026.95 376.85 1027.75 378.1 1028.55 379.3 1029.8 378.45 1033.8 375.55 1043.4 372.85 1052.75 370.2 1056.75 367.05 1062.05 362.85 1062.5 356.05 1062.9 349.8 1059.2 343.8 1055.5 337.65 1049 334.05 1042.8 330.65 1035.35 330.1 1028.25 329.6 1021.65 332.1 1013.55 335.2 1012.55 341.35 1012.5 341.9 1012.9 342.25 1013.3 342.55 1013.8 342.35 Z"
				/>
			</g>

			<g id="Layer1_19_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 1030.9 345.35
Q 1027.95 344.75 1025.45 345.3 1022.2 346 1021.85 348.5 1021.8 348.9 1022.1 349.15 1023.2 349.95 1025.45 350.05 1028.3 350.1 1029.1 350.35 1032.55 351.35 1035.55 354.5 1036.6 355.7 1038.2 354.8 1039.8 353.9 1039.2 352.4 1037 346.65 1030.9 345.35 Z"
				/>
			</g>

			<g id="Layer1_20_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 957.15 411.9
Q 959.4 413.95 960.75 416.7 962.2 419.45 962.4 422.4 962.65 425 961.6 428.7 960.15 434.1 960 434.85 959.8 436.05 960.9 436.55 962 437.1 962.65 436 966.3 429.55 965.55 422.2 964.8 414.5 959.5 409.6 954.65 405.1 947.6 404.8 939.75 404.5 938.85 407.9 938.75 408.1 938.9 408.1 940.2 408.8 942.05 408.45 945.25 407.75 945.4 407.75 948.6 407.6 951.7 408.7 954.8 409.75 957.15 411.9 Z"
				/>
			</g>

			<g id="Layer1_21_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 862.45 518
Q 862.3 516.15 860.7 515.3 853.3 511.25 844.55 511.5 836.4 511.7 828.3 515.55 820.55 519.25 812.85 527 810.0060546875 529.8814453125 804.35 536.65 798.9240234375 512.5943359375 782.05 512.55 771.6 512.5 768.3 522.55 766.7958984375 527.09296875 766.85 533 760.36484375 527.8259765625 752.3 524.6 739.25 519.4 728.3 522.25 723.15 523.6 721.35 527.75 719.75 531.5 720.95 536.85 724 549.95 727.9 560.3 737.9 587 756.8 595.8 765.5 599.85 780.15 602 800.75 604.95 804.05 605.75 818.9 609.3 827.15 618.1 835.6 627.15 840 642.35 844.5 657.5 844.6 671.35 844.75 687.45 838.9 699.85 833.7 710.8 822.45 720.25 815.05 726.5 800.6 735.2 785.2 744.55 779.3 748.8 767.8 757.05 760.75 765.8 751.3 777.5 749.1 789.55 746.2 805 759.2 810.65 774.4 817.3 792.05 820.5 809.4 823.65 826.2 822.95 830.35 822.8 830.35 818.65 830.35 814.5 826.2 814.4 793.75 813.5 768.95 805.55 765.05 804.5 763 803.75 759.35 802.4 757.8 800.6 755.75 798.25 756 793.7 756.15 790.85 757.4 786.45 760.3 776 769.5 766.1 776.35 758.8 787.3 751.45 789.7 749.8 807.05 739.1 819.1 731.65 826 725.85 835.65 717.85 841.4 708.65 847.55 698.8 849.45 686.1 851.2 674.45 849.2 662.05 847 648.3 843.85 638.65 839.65 625.95 833 617.35 826.65 609.15 816.45 604.4 808.1 600.5 796.1 598.5 780.9 596.45 773.35 594.85 760.35 592.05 752.3 586.15 742.85 579.25 736.55 566.1 732.25 557.15 728.05 541.75 726.15 534.45 726.1 533.75 725.7 529.05 729.8 527.75 734.3 526.25 743.8 528.35 758.15 531.45 768.35 542.35 769.95 544.05 771.8 542.8 773.6 541.6 773.25 539.5 771.9 530.6 773.85 524.9 776.55 516.95 785.15 519.45 792.1 521.45 795.65 529.8 797.6 534.4 799.4 544.8 799.7 546.45 801.7 547 803.65 547.55 804.75 546.2 816.95 530.55 827.4 523.85 840.8630859375 515.15859375 852.85 519.7 845.5111328125 527.9720703125 836.45 536.75 827.8 545.1 815.2 556.15 813.7 557.45 815 559.1 816.3 560.75 817.95 559.75 841.05 545.85 861.45 521.1 862.6 519.7 862.45 518 Z"
				/>
			</g>

			<g id="Layer1_22_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 873.05 580.85
Q 871.45 581.85 864.45 586.65 854.8 593.3 847.95 599 840.55 605.05 831.7 613.25 829.4 615.55 829.25 615.8 827.8 617.75 829.65 618.55 830.05 618.65 830.2 618.5
L 830.5 618.15
Q 830.541015625 618.108984375 830.55 618.05 830.6267578125 618.0755859375 830.7 618.1 831.3 618.2 833.8 615.95
L 841 610.6
Q 852.7 602.2 854.9 600.65 865.1 593.6 869.15 591.2 871.05 590.05 877.15 586.95 882.2 584.4 884.95 582.5 887.25 580.95 886.2 578.2 885.2 575.45 882.35 576.35 878.15 577.7 873.05 580.85 Z"
				/>
			</g>

			<g id="Layer1_23_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 881.2 576.5
Q 880.95 576.75 881.1 577 883.7 581.3 888.15 587.15 890.65 590.45 895.7 597 903.55 607.7 910.25 618.4 918.4 631.35 921.75 641.35 923.9 647.85 924.3 654.3 924.65 660.35 923.55 667.45 923 670.65 926.05 671.55 929.05 672.4 930.1 669.25 933.9 657.6 929.1 642.7 925.6 631.7 917.15 618.4 910.3 607.6 901.15 596.15 895.7 589.45 892.1 585.6 886.75 579.95 881.7 576.4 881.45 576.2 881.2 576.5 Z"
				/>
			</g>

			<g id="Layer1_24_MEMBER_100_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 509.65 854.05
Q 508.95 856.45 511.35 856.95 516.75 858.15 532.7 861.45 546.05 864.2 554 866.15 575.05 871.35 595.15 877.3 633.35 888.6 676.65 905.05 676.9 905.15 677.05 904.85 677.2 904.5 676.9 904.4 639.05 887.85 596.85 874.6 576.1 868.1 555 862.45 541 858.7 533.95 856.9 521.75 853.8 512.7 852.1 510.35 851.65 509.65 854.05 Z"
				/>
			</g>

			<g id="Layer1_24_MEMBER_101_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 513.65 947.15
Q 533.75 942.3 565 935.45 584.9 931.05 616.55 924.6
L 642.45 919.6
Q 657.95 916.6 668.15 914.1 671.1 913.35 670.25 910.5 669.4 907.65 666.5 908.1 655.65 909.75 640.6 912.8 623.4 916.4 614.8 918.15 586.7 923.8 563.25 929.05 514.5 939.9 461.45 955.75 459.15 956.45 459.8 958.85 460.45 961.25 462.75 960.55 485.6 953.9 513.65 947.15 Z"
				/>
			</g>

			<g id="Layer1_24_MEMBER_102_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 487.05 975.3
Q 488.55 972.7 486.05 971.2 446.8 947.15 396 918.8 367.65 903 350.75 893.9 325.7 880.4 304.85 870.2 279.7 857.85 252.1 844 251.6 843.75 251.3 844.25 251 844.8 251.5 845 294.6 866.6 343.05 893.75 383.1 916.2 432.75 945.8 447.65 954.65 483.05 976.35 485.5 977.9 487.05 975.3 Z"
				/>
			</g>

			<g id="Layer1_24_MEMBER_103_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 197.05 654.95
Q 195.8 655.3 196.1 656.5 202.9 682.05 218.5 739.7 233.1 793.45 240.85 822.9 240.95 823.25 241.3 823.15 241.7 823.05 241.6 822.7 234.15 794.25 220.1 739.25 205.7 682.9 198.6 655.85 198.3 654.6 197.05 654.95 Z"
				/>
			</g>

			<g id="Layer1_24_MEMBER_104_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 424.45 708.35
Q 425.95 718.55 429.1 733.6 430.85 742 434.4 758.75 440.55 789.55 444.05 809.15 450.7 846.8 460.35 909.5 462.3 921.8 464.6 937.8 465.25 942.25 466.25 951.7 467.4 960 469.6 965.1 469.8 965.6 470.45 965.5 471.1 965.45 471.15 964.9 471.8 960.35 470.95 953.75 469.75 946.25 469.25 942.65
L 465.65 917.2
Q 461 885.15 457.85 866.45 449.75 818.9 439.4 764.5 435.95 745.4 434.1 735.85 430.85 719.25 427.65 707.45 427.2 705.9 425.7 706.35 424.2 706.8 424.45 708.35 Z"
				/>
			</g>

			<g id="Layer1_24_MEMBER_105_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 265.1 667.5
Q 288.4 672.6 318.45 678.95
L 399.05 695.95
Q 403.2 696.85 411.75 698.85 419.3 700.5 424.55 700.75 425.1 700.8 425.15 700.25 425.15 699.75 424.7 699.6 419.5 697.55 411.4 695.85 402.2 694.1 397.75 693.1
L 370.7 687
Q 340.4 680.15 317.55 674.75
L 237.45 655.9
Q 228.95 653.7 224.6 652.6 216.9 650.65 211.6 650.15 209.35 649.95 209.15 652.25 208.95 654.5 210.9 655.25 216.15 657.2 224.3 658.85 228.9 659.8 237.95 661.55
L 265.1 667.5 Z"
				/>
			</g>
		</defs>

		<g transform="matrix( 0.218994140625, 0, 0, 0.218994140625, -32.55,-26.95) ">
			<use xlinkHref="#Layer3_0_FILL" />
		</g>

		<g transform="matrix( 0.218994140625, 0, 0, 0.218994140625, -32.55,-26.95) ">
			<use xlinkHref="#Layer2_0_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_0_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_1_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_2_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_3_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_4_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_5_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_6_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_7_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_8_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_9_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_10_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_11_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_12_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_13_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_14_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_15_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_16_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_17_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_18_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_19_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_20_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_21_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_22_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_23_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.218963623046875, 0, 0, 0.218963623046875, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_24_MEMBER_100_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.218963623046875, 0, 0, 0.218963623046875, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_24_MEMBER_101_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.218963623046875, 0, 0, 0.218963623046875, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_24_MEMBER_102_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.218963623046875, 0, 0, 0.218963623046875, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_24_MEMBER_103_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.218963623046875, 0, 0, 0.218963623046875, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_24_MEMBER_104_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.218963623046875, 0, 0, 0.218963623046875, -32.55,-26.95) ">
			<use xlinkHref="#Layer1_24_MEMBER_105_MEMBER_100_FILL" />
		</g>
	</svg>
);
